/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.moderation.cancelScheduledActions'

export { $nsid }

/** Cancel all pending scheduled moderation actions for specified subjects */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    subjects: l.array(l.string({ format: 'did' }), { maxLength: 100 }),
    comment: l.optional(l.string()),
  }),
  l.payload(
    'application/json',
    l.ref<CancellationResults>((() => cancellationResults) as any),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

type CancellationResults = {
  $type?: 'tools.ozone.moderation.cancelScheduledActions#cancellationResults'

  /**
   * DIDs for which all pending scheduled actions were successfully cancelled
   */
  succeeded: l.DidString[]

  /**
   * DIDs for which cancellation failed with error details
   */
  failed: FailedCancellation[]
}

export type { CancellationResults }

const cancellationResults = l.typedObject<CancellationResults>(
  $nsid,
  'cancellationResults',
  l.object({
    succeeded: l.array(l.string({ format: 'did' })),
    failed: l.array(
      l.ref<FailedCancellation>((() => failedCancellation) as any),
    ),
  }),
)

export { cancellationResults }

type FailedCancellation = {
  $type?: 'tools.ozone.moderation.cancelScheduledActions#failedCancellation'
  did: l.DidString
  error: string
  errorCode?: string
}

export type { FailedCancellation }

const failedCancellation = l.typedObject<FailedCancellation>(
  $nsid,
  'failedCancellation',
  l.object({
    did: l.string({ format: 'did' }),
    error: l.string(),
    errorCode: l.optional(l.string()),
  }),
)

export { failedCancellation }
